import React, { ComponentProps } from 'react'

import { selectStyles } from './SelectionDropdownShards'
import { Select } from './SelectionDropdownView'

export default <Option extends unknown, IsMulti extends boolean = false>({ ...props }: ComponentProps<typeof Select<Option, IsMulti>>) => {
  return <Select styles={selectStyles} {...props} />
}
